/**
 * Minimal query for backfill scripts - does NOT request eodTrackId/eodSortKey
 * to avoid "Cannot return null for non-nullable type" errors when these fields are missing.
 */
export const listTrackCarsForBackfill = /* GraphQL */ `
  query ListTrackCarsForBackfill(
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrackCars(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        areaId
        zoneId
        aisleId
        trackId
        sortKey
        shipmentId
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listTrackCarsForMigration = /* GraphQL */ `
  query ListTrackCarsForMigration(
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrackCars(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        trackId
        sortKey
        eodTrackId
        eodSortKey
        shipmentId
        reloadYardId
        parentType
        inbound {
          id
          isCollected
        }
        outbound {
          id
          isCollected
        }
      }
      nextToken
    }
  }
`;

export const trackManagementTrackCarFields = /* GraphQL */ `
  id
  active
  trackId
  sortKey
  eodTrackId
  eodSortKey
  parentType
  railCarNumber
  accountId
  shipmentId
  reloadYardId
  locationFullName
  inbound {
    id
    status
    state
    poNumber
    accountName
    account {
      id
      color
    }
    reloadYardCommodityId
    carrierEquipmentTypeId
    railEquipmentType {
      id
      name
      length
    }
    createDateTime
    scheduledDateTime
    notifyDateTime
    placedDateTime
    startDateTime
    endDateTime
    releaseDateTime
    isCollected
    sit
    inventories {
      items {
        id
        productId
        productName
        product {
          color
        }
        inventoryItems {
          items {
            id
            status
            locationId
          }
        }
      }
    }
  }
  outbound {
    id
    status
    state
    carrierType
    poNumber
    accountName
    account {
      id
      color
      verifyOutboundRailCar
    }
    reloadYardCommodityId
    carrierEquipmentTypeId
    railEquipmentType {
      id
      name
      length
    }
    createDateTime
    scheduledDateTime
    arrivalDateTime
    placementDateTime
    endDateTime
    departureDateTime
    shipmentLineItems {
      items {
        inventory {
          productId
          productName
          product {
            color
          }
        }
      }
    }
  }
`;

export const trackCarByActiveByTrackBySortKeyMini = /* GraphQL */ `
  query TrackCarByActiveByTrackBySortKeyMini(
    $reloadYardId: ID
    $activeTrackIdSortKey: ModelTrackCarTrackCarByActiveByTrackBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trackCarByActiveByTrackBySortKey(
      reloadYardId: $reloadYardId
      activeTrackIdSortKey: $activeTrackIdSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ${trackManagementTrackCarFields}
      }
      nextToken
    }
  }
`;

export const getTrackCarForTrackManagement = /* GraphQL */ `
  query GetTrackCarForTrackManagement($id: ID!) {
    getTrackCar(id: $id) {
      ${trackManagementTrackCarFields}
      location {
        id
        reloadYardId
        capacityUsed
        capacityAllocated
        length
      }
    }
  }
`;

export const trackCarByActiveByTrackByEodSortKeyMini = /* GraphQL */ `
  query TrackCarByActiveByTrackByEodSortKeyMini(
    $reloadYardId: ID
    $activeEodTrackIdEodSortKey: ModelTrackCarTrackCarByActiveByEodTrackByEodSortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trackCarByActiveByTrackByEodSortKey(
      reloadYardId: $reloadYardId
      activeEodTrackIdEodSortKey: $activeEodTrackIdEodSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        trackId
        sortKey
        eodTrackId
        eodSortKey
        parentType
        railCarNumber
        accountId
        shipmentId
        reloadYardId
        location {
          productId
          productName
        }
        inbound {
          id
          status
          state
          poNumber
          railCarNumber
          accountName
          accountId
          reloadYardCommodityId
          carrierEquipmentTypeId
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          inventories {
            items {
              id
              productId
              productName
              product {
                color
              }
              inventoryItems {
                items {
                  id
                  status
                  locationId
                }
              }
            }
          }
        }
        outbound {
          id
          status
          state
          poNumber
          railCarNumber
          accountName
          accountId
          reloadYardCommodityId
          carrierEquipmentTypeId
          railEquipmentType {
            id
            name
            length
          }
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          endDateTime
          shipmentLineItems {
            items {
              inventory {
                productId
                productName
                product {
                  color
                }
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;
